import React, { Component } from 'react'
import { Slider, Divider, Row, Col, Button } from 'antd'
import Cropper from 'react-easy-crop'
import getImageCropped from '../../helpers/image-crop.helper'

type ImageCropperProps = {
  src: string,
  zoom: number,
  aspect: number,
  onFinish?: (imageBase64: string) => void,
  onCancel?: () => void
}

export default class ImageCropper extends Component<ImageCropperProps> {

  static defaultProps = {
    zoom: 1,
    aspect: 4 / 3
  }

  state = {
    crop: { x: 0, y: 0 },
    croppedAreaPixels: null,
    zoom: this.props.zoom
  }

  onCropChange = crop => {
    this.setState({
      crop
    })
  }

  onCropComplete = async (croppedArea, croppedAreaPixels) => {
    this.setState({
      croppedAreaPixels
    })
  }

  onZoomChange = zoom => {
    this.setState({ zoom })
  }

  handleCancel = () => {
    const { onCancel } = this.props

    if (onCancel) {
      onCancel()
    }
  }

  handleSave = async () => {
    const { src, onFinish } = this.props
    const { croppedAreaPixels } = this.state

    if (onFinish) {
      const imageBase64 = await getImageCropped(src, croppedAreaPixels)
      onFinish(imageBase64)
    }
  }

  render() {
    const { src, aspect } = this.props
    const { crop, zoom } = this.state

    return (
      <div>
        <Cropper
          image={src}
          crop={crop}
          zoom={zoom}
          aspect={aspect}
          style={{containerStyle: { height: 350, marginTop: 55 }}}
          onCropChange={this.onCropChange}
          onCropComplete={this.onCropComplete}
          onZoomChange={this.onZoomChange}
        />      

        <Slider
          min={1}
          max={3}
          step={0.1}
          tooltipVisible={true}
          style={{marginTop: 350}}
          onChange={this.onZoomChange}
        />

        <Divider />

        <Row justify="end">
          <Col span={3}>
            <Button type="default" size="large" onClick={this.handleCancel}>
              Cancel
            </Button>
          </Col>

          <Col span={3}>
            <Button type="primary" size="large" onClick={this.handleSave}>
              Save
            </Button>
          </Col>
        </Row>
      </div>
    )
  }
}
